module.exports = __webpack_public_path__ + "static/media/image_66.b0aeb08a.png";